module.exports = __webpack_public_path__ + "static/media/9.bf076562.png";